module.exports = __webpack_public_path__ + "img/6.d58f7b91.png";